import React from 'react';
import Plans from '../component/plan/Plans';
import ComponenetHeader from '../component/common/ComponenetHeader';
import PlanImg1 from '../assets/plan_subscription.webp';
import { Helmet } from 'react-helmet';

const PlanPage = () => {
  return (
    <>
    <ComponenetHeader
      name={'Plans'}
    />

      <Helmet>
        <link rel="canonical" href="/plans"/>
        <title>Breakdown Inc Plans | Truck Repair Business Listings</title>
        <meta name="keywords" content="TruckRepair,DieselMechanic,MobileTruckRepair,HeavyDutyRepair,TruckService,FleetMaintenance,RoadsideAssistance,TruckBreakdown,TruckMechanic,SemiTruckRepair"/>
        <meta name="description" content="Choose from Silver, Gold, or Diamond plans to list your truck repair business on Breakdown Inc and reach thousands of drivers across America."/>
        <meta property="og:title" content="Breakdown Inc Plans | Truck Repair Business Listings"/>
        <meta property="og:description" content="Choose from Silver, Gold, or Diamond plans to list your truck repair business on Breakdown Inc and reach thousands of drivers across America."/>
      </Helmet>

      <Plans/>

    <section className='new_plan-section'>
      <div className='container'>
        <div className='row justify-content-center align-items-center'>
            <div className='col-md-6'>
              <div className='plan_new_img'>
              <img src={PlanImg1} className='img-fluid' alt='Plan Subscription' />
              </div>
            </div>

            <div className='col-md-5'>
            <div className="section-title mb-2 text-left">
              <p className='mb-2'>- PRICING INFO -</p>
              <h1 className='mb-2 h1_title'>Flexible Subscription Plans </h1>
            </div>
            <div className='plan_new_content text-left'>
                <p className='mb-2'>
                BreakDown Inc is your go-to partner to boost visibility and drive growth in the
                transportation and trucking industry. Our directed advertising models assist service
                providers in reaching their target customers—be it looking for  tire repair service
                near you , tow truck service. We provide a performance-based platform that puts your
                services—such as <a href="https://breakdowninc.net/Service-Near-Me/Trailer-Repair/Washington-DC-USA">semi tire
                repair near you</a> —in the spotlight where and when they're needed most. By becoming
                part of BreakDown Inc, your company stands directly in front of the consumers
                actively searching for the solutions you offer.
                </p>

                <p className='mb-0'>
                Start risk-free with our free Bronze plan, which comes with all the tools you need to
                effectively promote your business. You can upgrade at any time to unlock more features
                and reach even more people.
                </p>

            </div>
          </div>

        </div>
      </div>
    </section>



    <section className='new_plan-table'>
      <div className='container'>
        <div className='row justify-content-center'>
        <div className='col-md-11'>

        <div className="section-title mb-md-5 mb-4">
              <p>- CHOOSE THE BEST -</p>
              <h2>Discover Your Perfect Plan </h2>
        </div>

        <div className='plan_table table-responsive'>
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col">Feature</th>
              <th scope="col">Bronze</th>
              <th scope="col">Silver</th>
              <th scope="col">Gold</th>
              <th scope="col">Diamond</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Image Display</th>
              <td><i className="fas fa-times"></i></td>
              <td><b>SMALL</b> <span className='small'>(550X250px)</span></td>
              <td><b>MEDIUM</b> <span className='small'>(550X400px)</span></td>
              <td><b>LARGE</b> <span className='small'>(550X600px)</span></td>
            </tr>
            <tr>
              <th scope="row">Distance Visibility</th>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
            </tr>
            <tr>
              <th scope="row">Company Name</th>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
            </tr>
            <tr>
              <th scope="row">Business Address</th>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
            </tr>
            <tr>
              <th scope="row">Contact Email</th>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
            </tr>
            <tr>
              <th scope="row">Contact Phone</th>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
            </tr>
            <tr>
              <th scope="row">Services Display</th>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
              <td><i className="fa fa-check"></i></td>
            </tr>
            <tr>
              <th scope="row">Listing Highlights</th>
              <td><i className="fas fa-times"></i></td>
              <td><i className="fas fa-times"></i></td>
              <td><i className="fas fa-times"></i></td>
              <td><i className="fa fa-check"></i></td>
            </tr>
          </tbody>
        </table>
        </div>


        </div>
        </div>
      </div>
    </section>



    </>
  );
};

export default PlanPage;
